<template>
    <div class="c-app">
        <TheSidebar v-if="!['CashSettlement','CashSettlementDetail','Woa','Wof','WoaDetail','WofDetail','WorkOrderDetail','WorkOrder','HisFundRequestDetail', 'HisPurchaseOrderDetail', 'HisCashSettlementDetail', 'HisStockAdjustmentDetail',
        'HisPurchaseRequestDetail', 'HisCsoDetail', 'HisCsrDetail','HisCashAdvanceDetail', 'Cso','CsoDetail','Csr','CsrDetail','CapexRequest','CapexRequestDetail','StockAdjustment','StockAdjustmentDetail','PurchaseOrder','PurchaseOrderDetail','CashAdvanceDetail','CashAdvance','PurchaseRequest','PurchaseRequestDetail','CoalInventoryDetail','HaulingDetail','Notes','Discharge','DischargeDetail','FundRequest','FundRequestDetail','BudgetDetail','Logout'].includes($route.name)" />
        <CWrapper>
            <TheHeader v-if="!['CashSettlement','DashboardProduction','DashboardMiningOperation','DashboardSmm','DashboardHrm','Woa','Wof','WoaDetail','WofDetail','DashboardHaulingSite','DashboardHauling','Home','Approval','WorkOrderDetail','WorkOrder','CashSettlementDetail','CoalProduction','CoalSales','ProfitLoss','Profile', 'HisFundRequestDetail', 'HisPurchaseOrderDetail', 'HisCashSettlementDetail', 'HisStockAdjustmentDetail','HisPurchaseRequestDetail', 'HisCsoDetail', 'HisCsrDetail','HisCashAdvanceDetail','Cso','CsoDetail','Csr','CsrDetail','CapexRequest','CapexRequestDetail','StockAdjustment','StockAdjustmentDetail','PurchaseOrder','PurchaseOrderDetail','CashAdvanceDetail','CashAdvance','PurchaseRequest','PurchaseRequestDetail','CoalInventoryDetail','HaulingDetail','Notes','Discharge','CoalInventory','History','Hauling','DischargeDetail','FundRequest','FundRequestDetail','Budget','BudgetDetail','Logout'].includes($route.name)" />
            <div class="c-body">
                <main class="c-main">
                    <CContainer fluid>
                        <transition name="fade" mode="out-in">
                            <router-view :key="$route.path"></router-view>
                        </transition>
                    </CContainer>
                </main>
            </div>
            <!--<TheFooter/>-->
        </CWrapper>
    </div>
</template>
<script>
    import TheSidebar from './TheSidebar'
    import TheHeader from './TheHeader'
    import TheFooter from './TheFooter'

    export default {
        name: 'TheContainer',
        components: {
            TheSidebar,
            TheHeader,
            TheFooter
        }
    }
</script>
<style scoped>

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }
</style>
